



















import Vue from 'vue';
import api from '@/common/api';

export default Vue.extend({
  props: {
    lineItemName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      autoCompleteSearch: '' as string,
      autoCompleteSearchLoading: false as boolean,
      autoCompleteSearchResults: [] as any[],
      product: '' as string,
      isEditInit: false as boolean,
    };
  },
  mounted() {
    if (this.lineItemName) {
      this.product = this.lineItemName;
      this.isEditInit = true;
    }
  },
  watch: {
    autoCompleteSearch() {
      if (this.autoCompleteSearch === '' || !this.autoCompleteSearch
      || this.autoCompleteSearchLoading) return;
      this.autoCompleteSearchLoading = true;
      api
        .get('/merchant/products-autocomplete', {
          params: {
            q: this.autoCompleteSearch,
          },
        })
        .then(({ data: { data: searchResult } }) => {
          this.autoCompleteSearchResults = searchResult.map((result: any) => ({
            text: result.name,
            value: {
              rate: result.rate,
              description: result.description,
              measurementUnit: result.measurementUnit,
            },
          }));
        })
        .finally(() => {
          this.autoCompleteSearchLoading = false;
          this.setSelected();
        });
    },
  },
  methods: {
    setSelected() {
      let product = {};

      if (this.product !== '' && this.autoCompleteSearchResults.length > 0 && !this.isEditInit) {
        product = {
          name: this.autoCompleteSearchResults[0].text,
          rate: this.autoCompleteSearchResults[0].value.rate,
          description: this.autoCompleteSearchResults[0].value.description,
          measurementUnit: this.autoCompleteSearchResults[0].value.measurementUnit,
        };
      } else {
        product = {
          name: this.autoCompleteSearch,
        };
      }
      this.isEditInit = false;
      this.$emit('handleProduct', product);
    },
  },
});
